export enum MemberType {
  MEMBER = 'member',
  REDSHIRT = 'redshirt',
  CAPTAIN = 'captain',
  PENDING = 'pending',
}

export const isRedshirt = (member: { member_type?: string } | null | undefined): boolean => {
  return (member?.member_type ?? null) === MemberType.REDSHIRT
}

export const isCaptain = (member: { member_type?: string } | null | undefined): boolean => {
  return (member?.member_type ?? null) === MemberType.CAPTAIN
}

export const isRegularMember = (member: { member_type?: string } | null | undefined): boolean => {
  return (member?.member_type ?? null) === MemberType.MEMBER
}

/**
 * Check if a member is in the Free-Range Red Shirts subkrewe
 * These members don't do normal wristband pickup - they get equipment at Equipment Station
 */
export const isFreeRangeRedshirt = (member: { subkrewe?: { specialty?: string[] } | null } | null | undefined): boolean => {
  return member?.subkrewe?.specialty?.includes('redshirtFreeFloating') === true
}

/**
 * Check if a member is in the Nerd Herders subkrewe
 * These members don't do normal wristband pickup - they get equipment at Equipment Station
 */
export const isNerdHerder = (member: { subkrewe?: { specialty?: string[] } | null } | null | undefined): boolean => {
  return member?.subkrewe?.specialty?.includes('redshirtNerdHerders') === true
}

/**
 * Check if a member is a specialty redshirt (Free-Range or Nerd Herder)
 * These members use Equipment Station instead of normal check-in
 */
export const isSpecialtyRedshirt = (member: { subkrewe?: { specialty?: string[] } | null } | null | undefined): boolean => {
  return isFreeRangeRedshirt(member) || isNerdHerder(member)
}
